function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".BLT_Logo_Orange_svg__cls-1{fill:#fbaa19}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "BLT_Logo_Orange_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "BLT_Logo_Orange_svg__Front"
}, React.createElement("g", {
  id: "BLT_Logo_Orange_svg__Layer_23_copy",
  "data-name": "Layer 23 copy"
}, React.createElement("path", {
  className: "BLT_Logo_Orange_svg__cls-1",
  d: "M44.11 0H26.78v3.16h5.86v12.67h5.61V3.16h5.86V0z"
}), React.createElement("path", {
  className: "BLT_Logo_Orange_svg__cls-1",
  d: "M31.99 12.67h-8.58V0H17.8v15.83h14.19v-3.16zM17.25 10.94a4.61 4.61 0 00-2.2-3.8A3.86 3.86 0 0016 4.6C16 2.06 13.38 0 10.09 0H0v15.83h11.52c3.19-.1 5.73-2.25 5.73-4.89zm-8-4.89H5.09V3.16h4.2c1.05 0 1.9.63 1.9 1.44a1.71 1.71 0 01-1.9 1.45zM5.09 9.21H10a2 2 0 012.24 1.73A2 2 0 0110 12.67H5.09z"
}))));

var SvgBltLogoOrange = function SvgBltLogoOrange(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 44.11 15.83"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NC4xMSAxNS44MyI+CjxkZWZzPgogIDxzdHlsZT4KICAgIC5jbHMtMSAgewogICAgICBmaWxsOiNmYmFhMTk7CgogICAgICB9CiAgICA8L3N0eWxlPgo8L2RlZnM+PHRpdGxlPkFzc2V0IDE8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPgogIDxnIGlkPSJGcm9udCI+CiAgICA8ZyBpZD0iTGF5ZXJfMjNfY29weSIgZGF0YS1uYW1lPSJMYXllciAyMyBjb3B5Ij48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNDQuMTEgMCAyNi43OCAwIDI2Ljc4IDMuMTYgMzIuNjQgMy4xNiAzMi42NCAxNS44MyAzOC4yNSAxNS44MyAzOC4yNSAzLjE2IDQ0LjExIDMuMTYgNDQuMTEgMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIzMS45OSAxMi42NyAyMy40MSAxMi42NyAyMy40MSAwIDE3LjggMCAxNy44IDE1LjgzIDMxLjk5IDE1LjgzIDMxLjk5IDEyLjY3Ii8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTcuMjUsMTAuOTRhNC42MSw0LjYxLDAsMCwwLTIuMi0zLjhBMy44NiwzLjg2LDAsMCwwLDE2LDQuNkMxNiwyLjA2LDEzLjM4LDAsMTAuMDksMEgwVjE1LjgzSDExLjUyQzE0LjcxLDE1LjczLDE3LjI1LDEzLjU4LDE3LjI1LDEwLjk0Wm0tOC00Ljg5SDUuMDlWMy4xNmg0LjJjMS4wNSwwLDEuOS42MywxLjksMS40NEExLjcxLDEuNzEsMCwwLDEsOS4yOSw2LjA1Wk01LjA5LDkuMjFIMTBhMiwyLDAsMCwxLDIuMjQsMS43M0EyLDIsMCwwLDEsMTAsMTIuNjdINS4wOVoiLz48L2c+PC9nPjwvZz48L3N2Zz4K";
export { SvgBltLogoOrange as ReactComponent };